export const CAREPLANS = {
    HOW_IT_WORKS: 'HOW_IT_WORKS'
}